import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { ApplyCouponRoutingModule } from "./apply-coupon-routing.module";
import { ApplyCouponComponent } from "./apply-coupon.component";
import { ShimmerModule } from "../../common/modules/shimmer/shimmer.module";
import { HeaderMobileModule } from "../../layout/header-mobile/header-mobile.module";
import { NoItemAvailableModule } from "../common/no-item-available/no-item-available.module";

@NgModule({
  declarations: [ApplyCouponComponent],
  imports: [
    CommonModule,
    ApplyCouponRoutingModule,
    NoItemAvailableModule,
    ShimmerModule,
    HeaderMobileModule,
  ],
  exports: [ApplyCouponComponent],
})
export class ApplyCouponModule {}
